// extracted by mini-css-extract-plugin
export default {"description":"dB_f4","continueRead":"dB_nq","biography":"dB_k1","readMore":"dB_nr"};